import {
  getCountries,
  getCountryCallingCode,
  parsePhoneNumberFromString,
} from "libphonenumber-js";

// All real country calling codes, deduped (several countries share one, e.g. +1
// for US/Canada) and sorted numerically. Replaces a hardcoded short-list so any
// brand can register with their real country code.
export const COUNTRY_CODE_OPTIONS = Array.from(
  new Set(
    getCountries().map((country) => `+${getCountryCallingCode(country)}`),
  ),
).sort((a, b) => Number(a.slice(1)) - Number(b.slice(1)));

export const DEFAULT_COUNTRY_CODE = "+91";

// `digits` should already have whitespace stripped by the caller.
export function isValidPhoneNumber(countryCode, digits) {
  if (!digits) return false;
  const phoneNumber = parsePhoneNumberFromString(`${countryCode}${digits}`);
  return !!phoneNumber && phoneNumber.isValid();
}
